import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import {LInput} from '../../../../components/lInput';
import {AppService} from '../../../../dataServices/appService';
import {DebounceUtils} from '../../../../utils/debounceUtils';
import {PartnerDetails} from './partnerDetails';

export interface CardDetails {
  companyName?: string;
  urlSlug?: string;
  urlSlugValid?: -1 | 0 | 1;
}

export class CardDetailsStep extends Component<
  {
    cardDetails: CardDetails;
    partnerDetails: PartnerDetails;
    setCardDetails: (cardDetails: CardDetails) => void;
  },
  {validating: boolean}
> {
  state = {
    validating: false,
  };

  validateUrlSlug = (urlSlug: string) => {
    if (urlSlug.length === 0) {
      this.setState({validating: false});
      this.props.setCardDetails({...this.props.cardDetails, urlSlugValid: -1});
    } else {
      if (!urlSlug.match(/^[a-z0-9A-Z_-]+$/)) {
        this.props.setCardDetails({...this.props.cardDetails, urlSlugValid: 0});
        return;
      }
      this.setState({validating: true});
      DebounceUtils.debounce('urlSlug', 1000, async () => {
        if (!this.state.validating) {
          return;
        }
        const result = await AppService.adminPartnerClient.validateUrlSlugUnique({urlSlug}, {});
        if (!this.state.validating) {
          return;
        }
        this.props.setCardDetails({...this.props.cardDetails, urlSlugValid: result.valid ? 1 : 0});
        this.setState({validating: false});
      });
    }
  };
  render() {
    const {cardDetails, partnerDetails, setCardDetails} = this.props;
    return (
      <>
        <Row>
          <Col md={6}>
            <LInput value={partnerDetails.startingGroupCode} label={'Group Code'} disabled type={'text'} />
          </Col>
          <Col md={6}>
            <LInput value={partnerDetails.startingMemberId} label={'Member Id'} disabled type={'text'} />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <LInput
              value={cardDetails.companyName}
              onChange={(e) => setCardDetails({...cardDetails, companyName: e.target.value})}
              label={'Company Name'}
              placeholder={'optional'}
              type={'text'}
            />
          </Col>
          <Col md={6}>
            <LInput
              value={cardDetails.urlSlug}
              className={'no-highlight-input'}
              style={{
                borderWidth: cardDetails.urlSlugValid === -1 && !this.state.validating ? null : 3,
                borderColor:
                  cardDetails.urlSlugValid === 0
                    ? 'red'
                    : cardDetails.urlSlugValid === 1
                    ? 'green'
                    : this.state.validating
                    ? '#c1a437'
                    : null,
              }}
              onChange={(e) => {
                setCardDetails({...cardDetails, urlSlug: e.target.value});
                this.validateUrlSlug(e.target.value);
              }}
              label={'Url Slug'}
              placeholder={'optional'}
              type={'text'}
            />
          </Col>
        </Row>
      </>
    );
  }
}
